import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux'

import { Tabs, Tab, Box, Typography, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { ArrowRightAlt } from '@material-ui/icons';
import {UserSettingActiveTab} from '../../actions/userSetting';
import { userProfileLinkOptions } from '../../config/userProfileConfig';

import currentUserSelector from '../../selectors/currentUserSelector';


const useStyles = makeStyles({
    root: {},
    tabs: {
        '& .MuiTabs-indicator':{
            hidden: true,
        }

    },
    tab: {
        border: '1px solid #E5E5E5',
        width: '100%',
        '& .MuiTab-wrapper': {
            display: 'flex',
            flexDirection: 'row-reverse',
            justifyContent: 'space-between',
        },
        '&.MuiTab-labelIcon':{
            minHeight:'40px',
            maxWidth: '100%',
            textAlign: 'left'
        }
    }
})

function VerticalTabs({ options = [] }) {
    const [value, setValue] = useState(0);
    const currentUser = useSelector(currentUserSelector);
    const activeTab = useSelector(state => state.userSetting.userSettingActiveTab);

    const classes = useStyles();
    console.log(" +++ active tab  ++ selector ", activeTab)

    useEffect(() => {
        setValue(activeTab || 0);
    }, [activeTab])

    const dispatch = useDispatch();

    const handleChange = (event, newValue) => {
        console.log(" + tabValue +++" , newValue);
        setValue(newValue);
        dispatch(UserSettingActiveTab(newValue));
    }

    return (
        <Box display='flex' flexDirection='row' p={1.5} minHeight="460px">
            <Grid container>
                <Grid item xs={4}>
                    <Tabs
                        orientation="vertical"
                        variant="scrollable"
                        value={value}
                        onChange={handleChange}
                        aria-label="User Personal Setting Tab"
                        classsName={classes.tabs}
                    >
                        {
                            Array.isArray(options) && options.map(({ title, userRole }, index) =>
                                <Tab 
                                disabled={userRole.indexOf(currentUser?.userRole.toString()) === -1}
                                className={classes.tab}  
                                label={title} 
                                id={`vertical-tab-${index}`} 
                                icon= {<ArrowRightAlt/>}
                                aria-controls={`vertical-tabpanel-${index}`}> 
                               
                            </Tab>
                            )
                        }
                    </Tabs>
                </Grid>
                <Grid item xs={8}>
                    {
                        Array.isArray(options) && options.map((option, index) =>
                            (<TabPanel value={value} index={index}> <option.form /></TabPanel>)
                        )
                    }
                </Grid>
            </Grid>
        </Box>
    )
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >{
                value === index && (
                    <Box  pl={3} >
                        <Typography>{children}</Typography>
                    </Box>
                )
            }
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
}

export default VerticalTabs;